import { Leaf, HeartPulse, ShieldCheck, Package, ChefHat } from "lucide-react";
import { Section } from "@/components/Section";
import { useHomepageContent } from "@/hooks/useHomepageContent";
import { HOMEPAGE_FALLBACKS } from "@/lib/homepage-defaults";
import { useImageFallback } from "@/hooks/useImageFallback";

const ITEMS = [
  { icon: Leaf, title: "Farm Direct Ingredients", body: "Sourced from farmers we work with — traceable, seasonal, fresh." },
  { icon: HeartPulse, title: "Nutrition Experts", body: "Combos curated by food experts with nutrition-forward intent." },
  { icon: ShieldCheck, title: "Hygiene Standards", body: "Strict food-safety and hygiene protocols across every kitchen." },
  { icon: Package, title: "Food Grade Packaging", body: "Safe, hygienic packaging built for fresh, in-city delivery." },
  { icon: ChefHat, title: "Separate Kitchens", body: "Vegetarian and non-vegetarian meals prepared in fully separated kitchens." },
];

export function TrustQuality() {
  const content = useHomepageContent();
  const supporting = useImageFallback(HOMEPAGE_FALLBACKS.trustQualityImageUrl);
  return (
    <Section className="bg-secondary/30">
      <div className="max-w-2xl">
        <span className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Trust &amp; Quality</span>
        <h2 className="mt-3 font-display text-4xl font-medium md:text-5xl">Non-negotiables in every meal.</h2>
      </div>
      <div className="mt-10 overflow-hidden rounded-3xl ring-1 ring-border">
        <img
          src={content.trustQualityImageUrl}
          alt="Farm-fresh vegetables and grains beside premium food-grade takeaway packaging."
          width={1920}
          height={760}
          loading="lazy"
          decoding="async"
          onError={supporting.onError}
          className="aspect-[16/10] h-full w-full object-cover md:aspect-[21/8]"
        />
      </div>
      <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {ITEMS.map(({ icon: Icon, title, body }) => (
          <div key={title} className="rounded-2xl bg-card p-7 shadow-sm ring-1 ring-border/60">
            <Icon size={24} strokeWidth={1.5} className="text-primary" aria-hidden />
            <h3 className="mt-4 font-display text-lg font-medium">{title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{body}</p>
          </div>
        ))}
      </div>
    </Section>
  );
}